<div class="row center">
  <div class="library-header">
    <!-- <div class="bread-crumbs">
        <div
        class="custom lrg link padding left"
        [ngClass]="{ 'bold': selectedCylinder }"
        (click)="goToLibrary()">
          Cylinders
        </div>
        <i *ngIf="selectedCylinder" class="material-icons">keyboard_arrow_right</i>
        <div *ngIf="selectedCylinder" class="caption padding sm left">
          {{selectedCylinder.name}}
        </div>
      </div> -->
    <div class="library-header-left" *ngIf="!selectedCylinder">
      <button mat-button [matMenuTriggerFor]="menu">
        <mat-icon>filter_list_outline</mat-icon>
      </button>
      <div class="margin right">/</div>
      <mat-menu #menu="matMenu">
        <button mat-menu-item (click)="showUnverifiedCylinders()">Unverified Cylinders</button>
        <button mat-menu-item (click)="showSelectedCylinders()">Selected Cylinders</button>
        <button mat-menu-item (click)="showAllCylinders()">All Cylinders</button>
        <button mat-menu-item (click)="showCrossKeyedCylinders()">Cross Keyed Cylinders</button>
      </mat-menu>
      <span>{{ filteredTypeCylinder }}</span>
    </div>
    <span
      *ngIf="!selectedCylinder && (filteredTypeCylinder === CylinderType.UnverifiedCylinder || filteredTypeCylinder === CylinderType.CrossKeyedCylinder)"
      class="margin right"
      matTooltip="Run Pre-MECS for all eligible cross-keyed cylinders"
      style="display: inline-flex"
    >
      <button
        mat-stroked-button
        [disabled]="validateCylindersDisabled"
        (click)="onValidateCylinders()"
        style="font-size: 14px; letter-spacing: -0.1px; text-transform: none; font-weight: 400; background: white; width: 155px; min-width: 155px"
      >
        <mat-icon *ngIf="validateCylindersDisabled" class="validate-btn-tooltip">warning_outline</mat-icon>
        <mat-icon *ngIf="!validateCylindersDisabled" style="font-size: 14px; width: 14px; height: 14px; margin-right: 4px; color: #b9bec6">fact_check</mat-icon>
        Validate Cylinders
      </button>
    </span>
    <button
      mat-stroked-button
      (click)="getPinningReport()"
      [small]="true"
      [color]="'#393E46'"
      class="margin lrg top bottom left"
      *ngIf="selectedCylinder"
    >
      Pinning Report
    </button>
  </div>
</div>

<!-- Master Cylinders -->
<!-- <div
    *ngIf="filteredMasterKeyCylinders.length > 0 && selectedMasterKey && !selectedCylinder"
    [@slideInOnlyUpStaggered]="cylinderCounter"
  >
    <div class="caption margin top bottom left">Selected Master Key</div>
    <div
      class="library-list-item"
      *ngFor="let cylinder of filteredMasterKeyCylinders"
      (click)="selectCylinder(cylinder)"
    >
      <app-library-list-item [libraryItemData]="convertToListItem(cylinder)"> </app-library-list-item>
    </div>
  </div> -->

<!-- Sub Cylinders -->
<!-- (click)="selectCylinder(cylinder)" -->
<div class="margin bottom top" *ngIf="selectedMasterKey && !selectedCylinder">
  <!-- <div class="caption margin top bottom left">Sub Masters</div> -->
  <div class="row space-between margin all align-center">
    <div class="margin left col">
      Selected Master Key ({{ selectedCylindersCount }} / {{ filteredAllCylinders.length }})
    </div>
    <div class="col" style="width: 155px; overflow: hidden">
      <keycom-search
        style="width: 100%; display: flex"
        *ngIf="!selectedCylinder && !killSearch"
        placeholder="Search by cylinder"
        (onSearch)="filter($event)"
      ></keycom-search>
    </div>
  </div>

  <div class="margin all" *ngIf="filteredCylinderTypeCylinders.length > 0; else noResults">
    <cdk-virtual-scroll-viewport class="scroll" [itemSize]="28">
      <mat-card>
        <div class="padding all">
          <table class="mat-table">
            <thead role="rowgroup">
              <tr class="mat-header-row" role="row">
                <th class="mat-header-cell">
                  <input
                    class="margin right select"
                    [(ngModel)]="selectAllCheckbox"
                    (ngModelChange)="onClickAllCheckbox($event)"
                    type="checkbox"
                  />
                </th>
                <th class="mat-header-cell">Cylinder</th>
                <th class="mat-header-cell">Keyway</th>
                <th class="mat-header-cell">Setlist</th>
                <th class="mat-header-cell">Unverified Reason</th>
              </tr>
            </thead>
            <tbody role="rowgroup">
              <ng-container
                *cdkVirtualFor="let cylinder of filteredCylinderTypeCylinders; let i = index; let first = first"
              >
                <tr role="row" class="mat-row">
                  <td role="cell" class="mat-cell">
                    <input
                      class="margin right select"
                      (click)="onClickCheckbox($event, cylinder, i)"
                      type="checkbox"
                      [checked]="cylinder.selected"
                    />
                  </td>
                  <td role="cell" class="mat-cell">
                    <div
                      class="row align-start cursor"
                      [ngClass]="{
                        'versioned-cylinder': !cylinder?.isDefaultCylinder,
                        'default-cylinder': cylinder?.isDefaultCylinder
                      }"
                      (click)="selectCylinder(cylinder)"
                    >
                      <span
                        class="margin right cylinder-name"
                        [title]="getCylinderTypeTooltip(cylinder)"
                      >
                        <span [innerHTML]="cylinder?.highlightedName || cylinder?.name"></span>
                        <span *ngIf="cylinder?.competitorId === 3">(SAR)</span>
                        <span *ngIf="cylinder?.competitorId === 4">(COR)</span>
                      </span>
                      <span class="arrow margin right"></span>
                      <ng-container *ngIf="cylinder?.operatorRange?.length > 0; else showOperators">
                        <div class="operators-container">
                          <span
                            *ngFor="let op of getSortedOperatorRange(cylinder); trackBy: trackByOperator"
                            class="operator-badge"
                            [ngClass]="getOperatorRangeClass(op.masterKeyTypeId)"
                            [title]="getOperatorTypeTooltip(op.masterKeyTypeId)"
                          >
                            {{ op.displayText }}
                          </span>
                        </div>
                      </ng-container>
                      <ng-template #showOperators>
                        <div class="operators-container">
                          <div *ngFor="let op of cylinder?.operators">
                            <lib-key [hierarchyItem]="op.masterKey"></lib-key>
                          </div>
                        </div>
                      </ng-template>
                    </div>
                  </td>
                  <td role="cell" class="mat-cell">
                    {{ cylinder.keywayName }}
                  </td>
                  <td role="cell" class="mat-cell">
                    <button
                      *ngIf="cylinder.setlist"
                      type="button"
                      class="setlist-copy-btn"
                      [matTooltip]="cylinder.setlist"
                      matTooltipClass="setlist-tooltip"
                      (click)="copySetList($event, cylinder)"
                    >
                      <mat-icon>{{ copiedCylinderId === cylinder.id ? 'check' : 'content_copy' }}</mat-icon>
                    </button>
                  </td>
                  <td role="cell" class="mat-cell">
                    <div class="row" style="align-items: baseline" *ngIf="cylinder?.annotations.length > 0">
                      <span class="margin right annotations" [matTooltip]="displayAnnotations(cylinder)">
                        {{ displayAnnotations(cylinder) }}
                      </span>
                      <ng-container *ngIf="canVerifyCylinder(cylinder)">
                        <button mat-stroked-button (click)="verifyCylinder(cylinder.masterKeyId, cylinder.id)">
                          Verify Cylinder
                        </button>
                      </ng-container>
                    </div>
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>
      </mat-card>
    </cdk-virtual-scroll-viewport>
  </div>

  <ng-template #noResults>
    <div class="no-results margin all" *ngIf="!isLoadingCylinders">
      <mat-card>
        <div class="padding all" *ngIf="searchTerm; else noSearchResults">
          No cylinders found matching "{{ searchTerm }}"
        </div>
        <ng-template #noSearchResults>
          <div class="padding all">
            No cylinders available
          </div>
        </ng-template>
      </mat-card>
    </div>
  </ng-template>
</div>

<div class="col" padding="8px 8px 0 8" *ngIf="selectedCylinder">
  <!-- MECS -->
  <div class="row mecs" *ngIf="selectedCylinder?.isReadyForValidation">
    <div class="ready">
      <div class="icon-circle">
        <mat-icon color="white" [size]="18">check</mat-icon>
      </div>
      <h6 class="margin left">{{ selectedCylinder.name }} is ready for MECS!</h6>
    </div>
  </div>
  <div class="row mecs" *ngIf="cylinderValidation?.errors?.length > 0">
    <div class="errors" *ngFor="let error of cylinderValidation?.errors">
      <div class="icon-circle">
        <mat-icon color="white" [size]="18">times</mat-icon>
      </div>
      <h6 class="margin left">
        {{ error }}
      </h6>
    </div>
  </div>

  <!-- Operators -->
  <div class="row" *ngIf="selectedMasterKey && selectedCylinder">
    <app-operated-by-table
      [cylindersDisplayColumns]="cylindersDisplayColumns"
      [filteredCylinders]="filteredCylinders"
      [selectedCylinder]="selectedCylinder"
      [editing]="editing.operators"
      (onEdit)="editOperators()"
      (selectNewCylinder)="selectNewCylinder($event)"
      [structure]="structure"
      [keySystem]="keySystem"
      [selectedMasterKey]="selectedMasterKey"
    >
    </app-operated-by-table>
  </div>

  <!-- Shear Lines -->
  <div class="row">
    <app-shearline-input-array
      [selectedCylinder]="selectedCylinder"
      (addRowEvent)="addRow()"
      (inputUpdates)="shearLineChange()"
      (validateSaveShearline)="validateAndSaveShearline()"
      (sortShearLines)="onSortShearLines()"
      (resetShearLines)="onResetShearLines()"
      (generateShearLines)="onGenerateShearLines()"
      key="depth"
      [shearLines]="selectedCylinder?.formattedShearLines"
      [editing]="editing.shearLine"
      (onEdit)="editShearLine()"
      [structure]="structure"
      [keySystem]="keySystem"
      [selectedMasterKey]="selectedMasterKey"
      [hasControlKeyMaster]="hasControlKeyMaster"
      (prepareForMECS)="prepareForMECSHandler()"
    >
    </app-shearline-input-array>
  </div>
</div>
